exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reasonPickerModal__reasonList___1Lsfq {\n  display: flex;\n  flex-direction: column;\n  width: 100%; }\n\n.reasonPickerModal__reasonItem___3ZITj {\n  white-space: normal;\n  line-height: 1.4;\n  margin-bottom: 10px;\n  margin-left: 0; }\n\n.reasonPickerModal__fieldError___1M3te {\n  color: #f5222d;\n  font-size: 12px;\n  line-height: 1.5;\n  margin-top: -4px;\n  margin-bottom: 10px; }\n\n.reasonPickerModal__commentLabel___i7A6y {\n  margin-top: 16px;\n  margin-bottom: 6px;\n  font-weight: 500; }\n", ""]);

// exports
exports.locals = {
	"reasonList": "reasonPickerModal__reasonList___1Lsfq",
	"reasonItem": "reasonPickerModal__reasonItem___3ZITj",
	"fieldError": "reasonPickerModal__fieldError___1M3te",
	"commentLabel": "reasonPickerModal__commentLabel___i7A6y"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/routes/Admin/ReasonPickerModal/reasonPickerModal.scss
// module id = 1955
// module chunks = 6